import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Building2, AlertTriangle, AlertCircle, ShieldAlert, Wifi, Snowflake, KeyRound } from "lucide-react";

function Kpi({ icon: Icon, label, value, tone = "slate" }) {
  const tones = {
    slate: "bg-slate-900 text-white",
    orange: "bg-orange-500 text-white",
    red: "bg-red-500 text-white",
    black: "bg-black text-white",
    emerald: "bg-emerald-600 text-white",
  };
  return (
    <div className="bg-white rounded-2xl border border-slate-200 p-5 shadow-sm">
      <div className="flex items-center justify-between mb-2">
        <span className="text-sm text-slate-500 font-medium">{label}</span>
        <div className={`w-9 h-9 rounded-lg ${tones[tone]} flex items-center justify-center`}>
          <Icon className="w-4 h-4" />
        </div>
      </div>
      <div className="text-3xl font-bold font-display text-slate-900">{value}</div>
    </div>
  );
}

export default function Dashboard() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/dashboard").then((r) => setD(r.data)); }, []);
  if (!d) return <div className="p-8 text-slate-500">Chargement…</div>;

  return (
    <div className="p-4 md:p-8 max-w-7xl mx-auto space-y-6">
      <div>
        <h1 className="text-2xl md:text-3xl font-bold font-display text-slate-900">Tableau de bord</h1>
        <p className="text-sm text-slate-500 mt-1">Vue d'ensemble de votre parc</p>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        <Kpi icon={Building2} label="Appartements" value={d.total_apartments} tone="slate" />
        <Kpi icon={AlertTriangle} label="Anomalies ouvertes" value={d.open_problems} tone="orange" />
        <Kpi icon={AlertCircle} label="Anomalies majeures" value={d.major_problems} tone="red" />
        <Kpi icon={ShieldAlert} label="Anomalies critiques" value={d.critical_problems} tone="black" />
      </div>

      <div className="bg-white rounded-2xl border border-slate-200 p-5 shadow-sm">
        <h3 className="font-bold font-display text-slate-900 mb-4">Équipements</h3>
        <div className="grid md:grid-cols-3 gap-6">
          <div className="flex items-start gap-3">
            <Wifi className="w-5 h-5 text-emerald-500 mt-0.5" />
            <div className="flex-1">
              <div className="text-sm text-slate-500">Wi-Fi</div>
              <div className="text-xl font-bold text-slate-900">{d.equipment.wifi} / {d.equipment.total}</div>
            </div>
          </div>
          <div className="flex items-start gap-3">
            <Snowflake className="w-5 h-5 text-sky-500 mt-0.5" />
            <div className="flex-1">
              <div className="text-sm text-slate-500">Climatisation</div>
              <div className="text-xl font-bold text-slate-900">{d.equipment.ac} / {d.equipment.total}</div>
            </div>
          </div>
          <div className="flex items-start gap-3">
            <KeyRound className="w-5 h-5 text-slate-700 mt-0.5" />
            <div className="flex-1">
              <div className="text-sm text-slate-500">Bail mobilité</div>
              <div className="text-xl font-bold text-slate-900">{d.equipment.mobility_lease} / {d.equipment.total}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
